module.exports = __webpack_public_path__ + "static/media/back-coffee.f64aa4b2.webp";